<script setup>
import { distance } from "vmap";
import { useHttp } from "vutil";

const numbFmt = new Intl.NumberFormat("nb-NO", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const distFmt = new Intl.NumberFormat("nb-NO", { minimumFractionDigits: 1, maximumFractionDigits: 1 });

const { data, error, get } = useHttp(data => {
	data.forEach(s => (s.dist = distance(pos, [s.lng, s.lat])));
	data.sort((a, b) => a.dist - b.dist);

	return data;
});
let pos;

navigator.geolocation.getCurrentPosition(({ coords: { longitude: lng, latitude: lat } }) => {
	get(`/api/site/geo/area?min_lng=${lng-0.25}&min_lat=${lat-0.1}&max_lng=${lng+0.25}&max_lat=${lat+0.1}`);
	pos = [lng, lat];
}, (err) => {
	error.value = err.message;
});
</script>

<template>
	<div v-if="error" class="error">{{ error }}</div>
	<div v-else-if="data" class="list">
		<div v-if="data.length === 0">No chargers in this area</div>
		<div v-for="s in data" :key="s.id" class="site">
			<h1>{{ s.addr }}</h1>
			<div class="info">
				<div>{{ numbFmt.format(s.price_el / 80) }} <i>kr/kWh</i></div>
				<div>{{ numbFmt.format(s.price_park / 80) }} <i>kr/time</i></div>
				<div>{{ s.available }} <i>ledige</i></div>
				<div><img class="icon-location-dot"> {{ distFmt.format(s.dist / 1000) }} <i>km</i></div>
			</div>
		</div>
	</div>
</template>
